import { Button } from "@shared/ui";
import { ArrowLeft, ArrowRight } from "lucide-react";
import styles from "../styles.module.scss";
import { ReviewTab } from "./ProcessStep";

interface ProcessFooterProps {
  processedCount: number;
  skippedCount: number;
  reviewTab: ReviewTab;
  isImporting: boolean;
  onBack: () => void;
  onViewSkipped: () => void;
  onImport: () => void;
  confirmLabel?: string;
}

export function ProcessFooter({
  processedCount,
  skippedCount,
  reviewTab,
  isImporting,
  onBack,
  onViewSkipped,
  onImport,
  confirmLabel,
}: ProcessFooterProps) {
  return (
    <div className={styles.modalFooter}>
      <Button
        onClick={onBack}
        type="text"
        className={styles.backButton}
        icon={<ArrowLeft size={14} />}
      >
        Back
      </Button>
      <div className={styles.footerActions}>
        {skippedCount > 0 && reviewTab !== "error" && (
          <button
            type="button"
            className={styles.skippedLink}
            onClick={onViewSkipped}
          >
            {skippedCount} skipped
          </button>
        )}
        <Button
          onClick={onImport}
          disabled={isImporting || processedCount === 0}
          loading={isImporting}
          type="primary"
          className={styles.importButton}
          icon={<ArrowRight size={14} />}
          iconPosition="end"
        >
          {confirmLabel ?? `Add ${processedCount} to Brief`}
        </Button>
      </div>
    </div>
  );
}
